import React from 'react';
import styled from 'styled-components';
import useCreateDashboard from '../utils/useCreateDashboard';
import { theme } from '../../../styles/theme';
import { PrimaryButton } from '../../../components/Button';
import EmptyDashboardVector from '../components/EmptyDashboardVector';

const Container = styled.div`
  padding-top: 84px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  row-gap: 8px;
`;
const Title = styled.h1`
  margin: 0;
  font: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;
const SubTitle = styled.p`
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: ${theme.colors.secondary800};
`;

// We show this screen when user doesn't have any dashboards
const DashboardWelcomeScreen = () => {
  const { createDashboard, loading } = useCreateDashboard(true);

  return (
    <Container>
      <EmptyDashboardVector />
      <Title>Start building your first dashboard</Title>
      <SubTitle>
        {`Click 'New Dashboard' to get started with adding reports, text, or media`}
      </SubTitle>
      <PrimaryButton type="button" onClick={createDashboard} disabled={loading}>
        New Dashboard
      </PrimaryButton>
    </Container>
  );
};

export default DashboardWelcomeScreen;
